module.exports = __webpack_public_path__ + "img/christmas-light-small.e52224b4.svg";